import { render, staticRenderFns } from "./OrderBlock.vue?vue&type=template&id=3ed6804c"
import script from "./OrderBlock.vue?vue&type=script&lang=js"
export * from "./OrderBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports